import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
    padding: 16,
  },
  receiver: {
    marginBottom: 32,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#aaa",
    paddingVertical: 8,
  },
  textBold: {
    fontWeight: "bold",
  },
  input: {
    color: "green",
    fontSize: 24,
    textAlign: 'center'
  },
  summary: {
    marginTop: 16,
    marginBottom: 32,
  },
  spaceBetween: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
